<section class="stepper-container">
  <div class="icons">
    <div class="icons-row" *ngFor="let step of steps; let i = index; trackBy: trackById">
      <div class="separator" [ngClass]="{ 'd-none': i === 0, 'primary-color-bg': (step.isCompleted || step.isCurrent) && i !== 0 }"></div>
      <div *ngIf="step.isCompleted" class="icon-item primary-color-bg">
        <flo-svg-icon
          class="d-flex svg-wrapper checkmark svg-vertical-align-text-top "
          icon="icon-check-mark"
          width="1.5rem">
        </flo-svg-icon>
      </div>
      <div *ngIf="!step.isCompleted" class="icon-item">
        <div class="step" [ngClass]="{ 'primary-color-bg': step.isCurrent }">{{ step.id }}</div>
      </div>
      <div class="separator" [ngClass]="{ 'd-none': i === steps.length - 1, 'primary-color-bg': step.isCompleted }"></div>
    </div>
  </div>
  <div class="labels">
    <label
      *ngFor="let step of steps; let i = index; trackBy: trackById"
      class="text-400"
      [ngClass]="{'text-900': step.isCurrent}">
        {{ step.name }}
    </label>
  </div>
</section>